// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {ProcurementClient} from "./ProcurementClient"
import { Location } from "./models"


export interface Warehouse {
  service: string
  id: number
  ref: string
}


export interface ProcurementOrderDTO {
  access_code: string
  id: string
  buyer: string
  currency: string
  expected_delivery: string
  incoterms: string
  invoice_ref: string | null
  placed: string
  purchaser: {name: string}
  supplier: {name: string, supplier_id: string}
  location: Location
  warehouse: Warehouse | null
}


export default class ProcurementOrder {
  private client: ProcurementClient
  private params:  ProcurementOrderDTO

  constructor(client: ProcurementClient, params?: any) {
    this.client = client
    this.params = {
      supplier: {},
      ...(params || {}),
    } as ProcurementOrderDTO
  }

  getAccessCode(): string {
    return this.params.access_code
  }

  getId(): string {
    return this.params.id
  }

  getBuyerName(): string {
    return this.params.buyer
  }

  getInvoiceReference(): string {
    return this.params.invoice_ref || "-"
  }

  getExpectedDelivery(): string {
    return this.params.expected_delivery
  }

  getPlaced(): string {
    return this.params.placed
  }

  getReference(): string {
    return (!!this.params.warehouse) ? this.params.warehouse.ref : ""
  }

  getPurchaser(): string {
    return this.params.purchaser.name
  }

  getSupplierName(): string {
    return this.params.supplier.name
  }

  update(params: ProcurementOrderDTO) {
    this.params = {...this.params, ...params}
  }
}